import React from "react";
import ViewReverse from "./ViewReverse";
import Text from "./Text";
import { fontSizes } from "../constants/constants";
import dynamicfunction from "../utils/dynamicfunction";
import { ReactSVG } from "react-svg";
import icons from "../constants/icons";
import { cn } from "../utils/utils";

const CustomCheckbox = ({
  isChecked,
  label,
  onClick,
  className,
  secondText,
  onPressSecondText,
  connectorText,
  thirdText,
  onPressThirdText,
  labelWeight,
  size,
  color,
  secondColor,
  secondSize,
  weight,
  secondTextClasses,
  isRequired = false,
  isSecondTextRequired = false,
  checkBgColor = "bg-light-blue",
  checkBorderColor = "border-light-blue",
  isError = false,
  textRowClasses,
}) => {
  const { TextWeight } = dynamicfunction();
  return (
    <ViewReverse className={cn('items-center gap-2', className)}>
      <div
        className={cn(
          'w-5 h-5 min-w-5 min-h-5 flex items-center justify-center cursor-pointer rounded-md border',
          isChecked ? (checkBgColor ?? "bg-dark-blue") : "bg-transparent",
          isError ? "border-red-500" : isChecked ? (checkBorderColor ?? "border-dark-blue") : "border-grey"
        )}
        onClick={onClick}
      >
        {isChecked && <ReactSVG src={icons?.check} />}
      </div>
      <ViewReverse className={cn("w-full flex-wrap gap-2", textRowClasses)}>
        <Text
          text={label}
          size={size ?? fontSizes.h14}
          color={color ?? "text-dark-grey"}
          weight={weight ?? TextWeight.light}
          className={"cursor-pointer"}
          isTruncate={false}
          isRequired={isRequired}
          onClick={onClick}
        />
        {secondText && (
          <Text
            text={secondText}
            size={secondSize ?? fontSizes.h14}
            color={secondColor ?? "text-light-blue"}
            weight={TextWeight.bold}
            className={cn("-mx-1 cursor-pointer", secondTextClasses)}
            onClick={onPressSecondText}
            isRequired={isSecondTextRequired}
          />
        )}
        {thirdText && (
          <>
            {connectorText && (
              <Text
                text={connectorText}
                size={size ?? fontSizes.h14}
                color={color ?? "text-dark-grey"}
                weight={weight ?? TextWeight.light}
                className={"cursor-pointer"}
                isTruncate={false}
                onClick={onClick}
              />
            )}
            <Text
              text={thirdText}
              size={secondSize ?? fontSizes.h14}
              color={secondColor ?? "text-light-blue"}
              weight={TextWeight.bold}
              className={cn("-mx-1 cursor-pointer", secondTextClasses)}
              onClick={onPressThirdText}
            />
          </>
        )}
      </ViewReverse>
    </ViewReverse>
  );
};

export default CustomCheckbox;
